import { ref } from 'vue';
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-76d670f0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content-wrap"
};
const _hoisted_2 = {
  class: "new-order-filter-header"
};
const _hoisted_3 = {
  class: "flex-list"
};
const _hoisted_4 = {
  class: "flex-left"
};
const _hoisted_5 = {
  class: "form-row"
};
const _hoisted_6 = {
  class: "quick-time-group"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "form-row"
};
const _hoisted_9 = {
  class: "appListPopover-content"
};
const _hoisted_10 = {
  class: "appListPopover-content-title"
};
const _hoisted_11 = {
  class: "inf-label"
};
const _hoisted_12 = {
  class: "inf-value"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
const _hoisted_14 = {
  class: "form-row"
};
const _hoisted_15 = {
  class: "form-row"
};
const _hoisted_16 = {
  class: "form-row"
};
const _hoisted_17 = {
  class: "flex-right"
};
const _hoisted_18 = {
  class: "form-row"
};
import { EditOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import useFilterHeader from './useFilterHeader';
import dayjs from 'dayjs';
import { ProductSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
import { addCollectFetch, removeCollectFetch } from '@/api/payManage/appManage';
import { detailFields, searchFields, getAppListInformation, copy } from '@/common';
import BatchModal from './BatchModal.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'FilterHeader',
  props: {
    loading: {
      default: false
    }
  },
  emits: ['filterSubmit', 'changeType', 'initDataSource'],
  setup(__props, {
    expose,
    emit
  }) {
    const {
      productSelectRef,
      payStatusList,
      payStatusListSmall,
      shipStatusList,
      reshipStatusList,
      isOpen,
      quickTimeList,
      verList,
      chnlList,
      originFilterForm,
      filterForm,
      appName,
      datePickerRef,
      changeQuickTime,
      changeApp,
      changeQueryTime
    } = useFilterHeader();
    const batchModalVisible = ref(false);
    const onFinish = () => {
      var _filterForm$time_rang, _filterForm$time_rang2;
      // 当查询时间=订单创建时间且未填写订单号时，校验dbtid
      if (filterForm.query_time === '1' && !filterForm.orderUnion && !filterForm.dbtId) {
        message.warning('请选择产品');
        return emit('initDataSource');
      }
      // 当查询时间=支付完成时间时，校验dbtid
      if (filterForm.query_time === '2' && !filterForm.dbtId) {
        message.warning('请选择产品');
        return emit('initDataSource');
      }
      // 判断结束时间是否大于开始时间31天
      if (filterForm.time_range.length > 0 && dayjs(filterForm.time_range[1]).diff(dayjs(filterForm.time_range[0]), 'day') > 31) {
        message.warning('时间范围不能超过31天,已自动调整为31天');
        // 修改结束时间
        filterForm.time_range[1] = dayjs(filterForm.time_range[0]).add(31, 'day').endOf('day').format('YYYY-MM-DD HH:mm:ss');
      }
      // 判断是否选择了自定义时间
      if (((_filterForm$time_rang = filterForm.time_range[0]) === null || _filterForm$time_rang === void 0 ? void 0 : _filterForm$time_rang.length) === 8) {
        filterForm.time_range[0] = dayjs(filterForm.time_range[0]).format('YYYY-MM-DD') + ' 00:00:00';
      }
      if (((_filterForm$time_rang2 = filterForm.time_range[1]) === null || _filterForm$time_rang2 === void 0 ? void 0 : _filterForm$time_rang2.length) === 8) {
        filterForm.time_range[1] = dayjs(filterForm.time_range[1]).format('YYYY-MM-DD') + ' 23:59:59';
      }
      let params = {};
      params = {
        ...filterForm,
        appName: appName.value
      };
      // 订单创建时间
      if (filterForm.time_range.length > 0 && filterForm.query_time === '1') {
        params.preOrderTimeStart = dayjs(filterForm.time_range[0]).format('YYYY-MM-DD HH:mm:ss');
        params.preOrderTimeEnd = dayjs(filterForm.time_range[1]).format('YYYY-MM-DD HH:mm:ss');
      }
      // 支付完成时间
      if (filterForm.time_range.length > 0 && filterForm.query_time === '2') {
        params.thirdPayTimeStart = dayjs(filterForm.time_range[0]).format('YYYY-MM-DD HH:mm:ss');
        params.thirdPayTimeEnd = dayjs(filterForm.time_range[1]).format('YYYY-MM-DD HH:mm:ss');
      }
      delete params.time_range;
      delete params.quick_time;
      delete params.query_time;
      emit('filterSubmit', params);
    }; // 订单列表搜索
    const resetForm = () => {
      Object.keys(filterForm).forEach(key => {
        filterForm[key] = originFilterForm[key];
      });
      datePickerRef.value.timeStart = dayjs('00:00:00', 'HH:mm:ss');
      datePickerRef.value.timeEnd = dayjs('23:59:59', 'HH:mm:ss');
      onFinish();
    }; // 重置搜索
    const changeStartHms = value => {
      filterForm.quick_time = null;
      filterForm.time_range[0] = dayjs(filterForm.time_range[0]).format('YYYYMMDD') + ' ' + value;
    }; // 修改开始时间
    const changeEndHms = value => {
      filterForm.time_range[1] = dayjs(filterForm.time_range[1]).format('YYYYMMDD') + ' ' + value;
    }; // 修改结束时间
    const showBatchModal = () => {
      batchModalVisible.value = true;
    };
    const getBatchIds = ids => {
      const idsList = [...new Set(ids.split(/\r?\n/).map(line => line.trim()).filter(line => line !== ''))];
      const useValue = idsList.join(';');
      filterForm.orderUnion = useValue;
    }; // 获取批量添加订单号
    // 添加收藏处理方法
    const handleFavorite = async (type, option) => {
      try {
        const fetchMethod = option.hasFavorite ? removeCollectFetch : addCollectFetch;
        if (!fetchMethod) {
          throw new Error('收藏方法未定义');
        }
        const {
          code
        } = await fetchMethod({
          dbtId: option.dbtId
        });
        if (code === '0') {
          message.success(`${option.hasFavorite ? '取消收藏' : '收藏'}成功`);
          option.hasFavorite = !option.hasFavorite;
        } else {
          throw new Error(`${option.hasFavorite ? '取消收藏' : '收藏'}失败`);
        }
      } catch (error) {
        console.error('收藏操作失败:', error);
        message.error('操作失败，请稍后重试');
      }
    };
    expose({
      changeApp,
      filterForm
    });
    return (_ctx, _cache) => {
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_DbtDatePicker = _resolveComponent("DbtDatePicker");
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_input = _resolveComponent("a-input");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_form, {
        layout: "inline",
        model: _unref(filterForm),
        onFinish: onFinish
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_a_form_item, {
          label: "查询时间"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: _unref(filterForm).query_time,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => _unref(filterForm).query_time = $event),
            style: {
              "width": "126px"
            },
            onChange: _unref(changeQueryTime)
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select_option, {
              value: "1"
            }, {
              default: _withCtx(() => [_createTextVNode("订单创建时间")]),
              _: 1
            }), _createVNode(_component_a_select_option, {
              value: "2"
            }, {
              default: _withCtx(() => [_createTextVNode("支付完成时间")]),
              _: 1
            })]),
            _: 1
          }, 8, ["value", "onChange"])]),
          _: 1
        }), _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_DbtDatePicker, {
            ref_key: "datePickerRef",
            ref: datePickerRef,
            "show-use-server-time": false,
            "show-header": false,
            "show-dynamic": false,
            "show-quick": false,
            "is-required": "",
            "show-time-range": "",
            startTime: _unref(filterForm).time_range[0],
            "onUpdate:startTime": _cache[1] || (_cache[1] = $event => _unref(filterForm).time_range[0] = $event),
            endTime: _unref(filterForm).time_range[1],
            "onUpdate:endTime": _cache[2] || (_cache[2] = $event => _unref(filterForm).time_range[1] = $event),
            position: "bottomLeft",
            onChangeStartHms: changeStartHms,
            onChangeEndHms: changeEndHms
          }, null, 8, ["startTime", "endTime"])]),
          _: 1
        }), _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(quickTimeList), item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.value,
              class: _normalizeClass(["quick-time-item", {
                active: _unref(filterForm).quick_time === item.value
              }]),
              onClick: $event => _unref(changeQuickTime)(item.value)
            }, _toDisplayString(item.label), 11, _hoisted_7);
          }), 128))])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_a_form_item, {
          label: "产品名称：",
          name: "dbtId"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ProductSelect), {
            ref_key: "productSelectRef",
            ref: productSelectRef,
            modelValue: _unref(filterForm).dbtId,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(filterForm).dbtId = $event),
            multiple: false,
            "show-icon": true,
            "show-extra": true,
            "search-fields": _unref(searchFields),
            "max-tag-count": 1,
            "show-detail": true,
            layout: "vertical",
            width: 200,
            "popup-class-name": "vertical-product-select",
            placeholder: "请选择",
            descriptionField: "filePath",
            detailFields: _unref(detailFields),
            onChange: _unref(changeApp),
            allowClear: _unref(filterForm).query_time === '1' && !!_unref(filterForm).orderUnion,
            "show-bottom-border": ""
          }, {
            icon: _withCtx(({
              type,
              option
            }) => [_createVNode(_component_SvgIcon, {
              iconClass: option.hasFavorite ? 'collectIcon' : 'collectGreyIcon',
              onClick: _withModifiers($event => handleFavorite(type, option), ["stop"]),
              class: "title-svg",
              style: {
                "margin": "0"
              }
            }, null, 8, ["iconClass", "onClick"])]),
            detail: _withCtx(({
              detail
            }) => [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_SvgIcon, {
              iconClass: "informationIcon",
              class: "informationIcon"
            }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
              return _openBlock(), _createElementBlock("div", {
                key: child.label,
                class: "inf-line"
              }, [_createElementVNode("div", _hoisted_11, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_12, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
                placement: "top"
              }, {
                title: _withCtx(() => [_hoisted_13]),
                default: _withCtx(() => [_createVNode(_component_SvgIcon, {
                  iconClass: "copy",
                  class: "dbt-copyIcon",
                  onClick: $event => _unref(copy)(child.value)
                }, null, 8, ["onClick"])]),
                _: 2
              }, 1024)]);
            }), 128))])]),
            _: 1
          }, 8, ["modelValue", "search-fields", "detailFields", "onChange", "allowClear"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "订单号：",
          name: "orderUnion",
          tooltip: "支持单独用订单号搜索"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            allowClear: "",
            value: _unref(filterForm).orderUnion,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => _unref(filterForm).orderUnion = $event),
            onChange: _cache[5] || (_cache[5] = e => _unref(filterForm).orderUnion = e.target.value.replace(/\s/g, '')),
            placeholder: "请输入DBT订单号/平台订单号",
            style: {
              "width": "210px"
            }
          }, {
            suffix: _withCtx(() => [_createVNode(_component_a_tooltip, {
              title: "批量输入订单号"
            }, {
              default: _withCtx(() => [_createVNode(_unref(EditOutlined), {
                onClick: showBatchModal
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "用户ID：",
          name: "userIdentityUnion",
          tooltip: "APP产品可用设备ID/访客ID搜索，小游戏可用openid搜索"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            allowClear: "",
            value: _unref(filterForm).userIdentityUnion,
            "onUpdate:value": _cache[6] || (_cache[6] = $event => _unref(filterForm).userIdentityUnion = $event),
            onChange: _cache[7] || (_cache[7] = e => _unref(filterForm).userIdentityUnion = e.target.value.replace(/\s/g, '')),
            placeholder: "请输入访客ID/设备ID/OpenID",
            style: {
              "width": "210px"
            }
          }, null, 8, ["value"])]),
          _: 1
        }), _withDirectives(_createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_button, {
            type: "link",
            onClick: _cache[8] || (_cache[8] = $event => isOpen.value = true)
          }, {
            default: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "arrow_blue"
            }), _createTextVNode(" 展开 ")]),
            _: 1
          })]),
          _: 1
        }, 512), [[_vShow, !_unref(isOpen)]])]), _withDirectives(_createElementVNode("div", _hoisted_14, [_createVNode(_component_a_form_item, {
          label: "支付状态：",
          name: "payStatus"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: _unref(filterForm).payStatus,
            "onUpdate:value": _cache[9] || (_cache[9] = $event => _unref(filterForm).payStatus = $event),
            style: {
              "width": "210px"
            },
            placeholder: "全部",
            options: _unref(filterForm).query_time === '1' ? _unref(payStatusList) : _unref(payStatusListSmall)
          }, null, 8, ["value", "options"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "道具状态：",
          name: "shipStatus"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: _unref(filterForm).shipStatus,
            "onUpdate:value": _cache[10] || (_cache[10] = $event => _unref(filterForm).shipStatus = $event),
            style: {
              "width": "210px"
            },
            placeholder: "全部",
            options: _unref(shipStatusList)
          }, null, 8, ["value", "options"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "复送状态：",
          name: "reshipStatus"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: _unref(filterForm).reshipStatus,
            "onUpdate:value": _cache[11] || (_cache[11] = $event => _unref(filterForm).reshipStatus = $event),
            style: {
              "width": "210px"
            },
            placeholder: "全部",
            options: _unref(reshipStatusList)
          }, null, 8, ["value", "options"])]),
          _: 1
        })], 512), [[_vShow, _unref(isOpen)]]), _withDirectives(_createElementVNode("div", _hoisted_15, [_createVNode(_component_a_form_item, {
          label: "支付渠道：",
          name: "payChnl"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: _unref(filterForm).payChnl,
            "onUpdate:value": _cache[12] || (_cache[12] = $event => _unref(filterForm).payChnl = $event),
            style: {
              "width": "210px"
            },
            placeholder: "全部",
            options: _unref(chnlList)
          }, null, 8, ["value", "options"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "内购ID：",
          name: "prodId"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: _unref(filterForm).prodId,
            "onUpdate:value": _cache[13] || (_cache[13] = $event => _unref(filterForm).prodId = $event),
            onChange: _cache[14] || (_cache[14] = e => _unref(filterForm).prodId = e.target.value.trim()),
            placeholder: "请输入内购ID",
            style: {
              "width": "210px"
            }
          }, null, 8, ["value"])]),
          _: 1
        })], 512), [[_vShow, _unref(isOpen)]]), _withDirectives(_createElementVNode("div", _hoisted_16, [_createVNode(_component_a_form_item, {
          label: "包名：",
          name: "pkg"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: _unref(filterForm).pkg,
            "onUpdate:value": _cache[15] || (_cache[15] = $event => _unref(filterForm).pkg = $event),
            onChange: _cache[16] || (_cache[16] = e => _unref(filterForm).pkg = e.target.value.trim()),
            placeholder: "请输入包名",
            style: {
              "width": "210px"
            }
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "应用版本：",
          name: "appVer"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: _unref(filterForm).appVer,
            "onUpdate:value": _cache[17] || (_cache[17] = $event => _unref(filterForm).appVer = $event),
            "show-search": "",
            placeholder: "全部",
            style: {
              "width": "210px"
            },
            options: _unref(verList)
          }, null, 8, ["value", "options"])]),
          _: 1
        }), _withDirectives(_createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_button, {
            type: "link",
            onClick: _cache[18] || (_cache[18] = $event => isOpen.value = false)
          }, {
            default: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "arrow_blue",
              class: "close-icon"
            }), _createTextVNode(" 收起 ")]),
            _: 1
          })]),
          _: 1
        }, 512), [[_vShow, _unref(isOpen)]])], 512), [[_vShow, _unref(isOpen)]])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_button, {
            onClick: resetForm
          }, {
            default: _withCtx(() => [_createTextVNode("重置")]),
            _: 1
          }), _createVNode(_component_a_button, {
            disabled: __props.loading,
            style: {
              "margin-left": "10px"
            },
            type: "primary",
            "html-type": "submit"
          }, {
            default: _withCtx(() => [_createTextVNode(" 搜索 ")]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        })])])])]),
        _: 1
      }, 8, ["model"])]), _createVNode(BatchModal, {
        modalVisible: batchModalVisible.value,
        "onUpdate:modalVisible": _cache[19] || (_cache[19] = $event => batchModalVisible.value = $event),
        initialValue: _unref(filterForm).orderUnion,
        onSubmitBatchId: getBatchIds
      }, null, 8, ["modalVisible", "initialValue"])]);
    };
  }
});